import { Deal } from "@mapmycustomers/shared/types/entity";
import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";

import DealClosedDateSettingValue from "@app/enum/DealClosedDateSettingValue";
import EditDealFormValues from "@app/util/form/EditDealFormValues";
import { formatDate } from "@app/util/formatters";
import isClosedStage from "@app/util/isClosedStage";

interface ResolveClosingDateOptions {
  closingDate: EditDealFormValues["closingDate"]; // date entered in the form (may be empty)
  nextStage: Stage; // stage the deal will have after this save
  previousStage: Stage; // stage the deal had before this save
  setting: DealClosedDateSettingValue | undefined; // org close-date-on-close preference
}

// Decides which closing date to persist when saving a deal.
//
// The "change to today" preference must only override the closing date when the deal
// actually transitions from an open stage into a closed (Won/Lost) stage. Editing any
// other field on an already-closed deal — or moving between two closed stages — must
// leave the closing date untouched.
const resolveClosingDate = ({
  closingDate,
  nextStage,
  previousStage,
  setting,
}: ResolveClosingDateOptions): Deal["closingDate"] => {
  if (!closingDate) {
    return null;
  }

  const transitionsIntoClosedStage = !isClosedStage(previousStage) && isClosedStage(nextStage);

  return setting === DealClosedDateSettingValue.CHANGE_TO_TODAY && transitionsIntoClosedStage
    ? formatDate(new Date(), "yyyy-MM-dd")
    : formatDate(closingDate, "yyyy-MM-dd");
};

export default resolveClosingDate;
